import { Fragment, useEffect, useMemo, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer } from "../../components"
import { usePost } from "../../api/reactQueryCustomHooks"
import { apiRoute, linksUrl } from "../../constants/enum"
import { useDispatch, useSelector } from "react-redux"
import { calculateTotalByKey, selectFilter, stickyParentClass } from "../../Utility/utility"
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import ExcelJS from 'exceljs';
import { saveAs } from "file-saver";
import jsPDF from "jspdf"
import { autoTable } from "jspdf-autotable"
import { useNavigate } from "react-router-dom"
import { resetStockLotno, setStockLotno } from "../../state/stockEntrySlice"
import { Button, Chip, Input } from "@heroui/react"
import { cond } from "lodash"
import { ConsoleView } from "react-device-detect"
import { toast } from "react-toastify"
import { faSearchPlus } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"


const num = (v) => {
    const n = Number(v);
    return isFinite(n) ? n : 0;
};

const fixed = (v, d = 2) => num(v).toFixed(d);
const LotWiseCostingReport = () => {
    const { compCode, compName } = useSelector((state) => state.company);
    const [searchText, setSearchText] = useState("")
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [selectedLots, setSelectedLots] = useState([]);

    const [inwardDate, setInwardDate] = useState({
        fromDate: null,
        toDate: null

    });
    const { isPending, isError, data: costinData = [], mutate: filterData } = usePost({
        url: apiRoute.stockEntry.getLotWiseCosting,
        queryKey: "lotwiseCosting"
    });

    const funFilterData = (fdate, tdate) => {

        filterData({
            data: {
                comp_code: compCode.join(","),
                trade_of: "P",
                //  from_date: fdate,
                // to_date: tdate
            }
        });
    }
    useEffect(() => {
        funFilterData(inwardDate.fromDate, inwardDate.toDate);
    }, [])
    const handleFilter = () => {
        if ((inwardDate.fromDate && inwardDate.fromDate == 'Invalid Date')
            || (inwardDate.toDate && inwardDate.toDate == 'Invalid Date')) {
            toast.error("Invalid From Date / To Date", {
                "position": "top-center"
            })
            return;
        }
        funFilterData(inwardDate.fromDate, inwardDate.toDate);

    }
    const data = useMemo(() => {
        if (!searchText) return costinData;

        const lowerSearch = searchText.toLowerCase();

        return costinData.filter(item =>
            Object.values(item).some(val =>
                val !== null &&
                val !== undefined &&
                val.toString().toLowerCase().includes(lowerSearch)
            )
        );
    }, [costinData, searchText]);



    const handleClear = () => {
        setInwardDate({ fromDate: null, toDate: null })
        funFilterData(null, null);

    }


    const STICKY_COL_WIDTH = {
        lotNo: 130,
        date: 100,
        roughWt: 80,
        polishWt: 80,
        cp: 80,
        ap: 80,
        diff: 80,
        diffPolWt: 80,
        planPcs: 80,
        planWt: 80,
        noSpace: 0
    };

    const stickyColumns = [

        "lotNo",
        "date",
        "roughWt",
        "polishWt",
        "cp",
        "ap",
        "diff",
        "diffPolWt",
        "planPcs",
        "planWt",
    ];

    const tblHeadClas = 'border-1 text-xs border-gray-500   px-3 py-2 text-center uppercase leading-tight'
    const tbltdClass = 'border-1 text-sm border-gray-300  px-3 py-2 text-right uppercase leading-tight'
    const tblfootdClass = 'border-1 text-sm border-gray-500 font-bold  px-3 py-2 text-right uppercase leading-tight'
    const StickyLeftCell = "sticky font-semibold text-center bg-gradient-to-r from-amber-200 to-amber-100 px-2 w-[130px] min-w-[130px]  max-w-[130px]  uppercase left-0 z-20  border-r-2 border-1 leading-tight border-slate-500 bg-gradient-to-r from-yellgow-100 to-yelglow-50";
    const getStickyLeft = (field) => {
        let left = 0;

        for (const col of stickyColumns) {
            if (col === field) break;
            left += STICKY_COL_WIDTH[col];
        }

        return left;
    };
    const getStickyStyle = (field, type) => ({
        position: "sticky",
        left: ` ${field == "date" ? STICKY_COL_WIDTH.lotNo : getStickyLeft(field)}px`,
        zIndex: 20,
        // width: `${STICKY_COL_WIDTH[field]}px`,
        minWidth: `${STICKY_COL_WIDTH[field]}px`,
        background: type == "head" ? "white" : ['planPcs', 'planWt'].includes(field) ? "#ecfeff" : "#fef2f2",
    });
    const block_Color = {
        LOT: 'bg-red-50',
        KP: 'bg-cyan-50',
        CD: 'bg-orange-50',
        NCD: 'bg-blue-50',
        HROW: "bg-white"
    }
    const totals = useMemo(() => {
        const init = {
            KP_L_Carat: 0,
            KP_P_Carat: 0,
            KP_LotCost: 0,
            CP_Amt: 0,
            Diff_Pol_Wt: 0,

            KP_Dem_Carat: 0,
            KP_Dem_Pcs: 0,

            CB_Carat: 0,
            CB_Pcs: 0,
            CB_AmountD: 0,

            CS_Carat: 0,
            CS_Pcs: 0,
            CS_AmountD: 0,

            NCB_Carat: 0,
            NCB_Pcs: 0,
            NCB_AmountD: 0,

            NCS_Carat: 0,
            NCS_Pcs: 0,
            NCS_AmountD: 0,
        };

        const total = data.reduce((acc, row) => {
            Object.keys(init).forEach((key) => {
                acc[key] += Number(row[key] || 0);
            });
            return acc;
        }, { ...init });

        // Average Price = Total KP_LotCost / Total KP_L_Carat
        total.Avg_CP =
            total.KP_L_Carat > 0
                ? total.CP_Amt / total.KP_L_Carat
                : 0;


        const totalAmount =
            total.CB_AmountD +
            total.CS_AmountD +
            total.NCB_AmountD +
            total.NCS_AmountD;

        const totalCarat =
            total.CB_Carat +
            total.CS_Carat +
            total.NCB_Carat +
            total.NCS_Carat;


        // Diff = (Total Amount / Total Carat) - Avg Price
        total.Avg_Price =
            totalCarat > 0
                ? totalAmount / totalCarat
                : 0;

        total.Diff =
            totalCarat > 0
                ? (totalAmount / totalCarat) - total.Avg_CP
                : 0;

        // If Diff_Pol_Wt means Diff * KP_P_Carat
        // total.Diff_Pol_Wt = total?.KP_Dem_Carat>0? totalCarat/total?.KP_Dem_Carat:0;

        return total;
    }, [data]);
    // const totals = useMemo(() => {
    //     const init = {
    //         KP_L_Carat: 0,
    //         KP_P_Carat: 0,
    //         KP_LotCost: 0,
    //         Avg_Price:0,
    //         Diff:0,
    //         Diff_Pol_Wt:0,
    //         KP_Dem_Carat: 0,
    //         KP_Dem_Pcs: 0,


    //         CB_Carat: 0,
    //         CB_Pcs: 0,
    //         CB_AmountD: 0,

    //         CS_Carat: 0,
    //         CS_Pcs: 0,
    //         CS_AmountD: 0,

    //         NCB_Carat: 0,
    //         NCB_Pcs: 0,
    //         NCB_AmountD: 0,

    //         NCS_Carat: 0,
    //         NCS_Pcs: 0,
    //         NCS_AmountD: 0,
    //     };

    //     return data.reduce((acc, row) => {
    //         Object.keys(init).forEach((key) => {
    //             acc[key] += Number(row[key] || 0);
    //         });
    //         return acc;
    //     }, init);
    // }, [data, searchText]);
    const funCalAvgRate = (value, carat) => {
        const x = Number(value);
        const y = Number(carat);

        if (!y || isNaN(x) || isNaN(y)) return 0;

        return x / y;
    }
    const exportToExcel = async () => {
        const fixNum = (v) => Number(v || 0);

        const applyNumberFormat = (cell) => {
            cell.numFmt = '#,##0.00';
        };

        const applyPositiveNegativeColor = (cell, value) => {
            cell.font = {
                ...(cell.font || {}),
                bold: true,
                color: {
                    argb: value < 0
                        ? "FFFF0000" // Red
                        : "FF008000" // Green
                }
            };
        };
        const formatDate = (dateValue) => {
            if (!dateValue || dateValue === '') return '';

            const date = new Date(dateValue);

            if (isNaN(date.getTime())) return '';

            return date.toLocaleDateString('en-GB'); // dd/mm/yyyy
        };
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Lot Wise Costing");

        // ===== Company Name =====
        worksheet.mergeCells("A1:W1");
        worksheet.getCell("A1").value = compName.join(",") || "Company Name";
        worksheet.getCell("A1").font = { size: 16, bold: true };
        worksheet.getCell("A1").alignment = { horizontal: "center" };

        // ===== Report Title =====
        worksheet.mergeCells("A2:W2");
        worksheet.getCell("A2").value = "Single Packet Lot Wise Costing Report";
        worksheet.getCell("A2").font = { size: 12, bold: true };
        worksheet.getCell("A2").alignment = { horizontal: "center" };

        // ===== HEADER ROW 1 =====
        const row1 = worksheet.addRow([
            "LOT NO.", "", "", "", "", "", "", "",
            "PLANNING", "",
            "CERTI BALANCE STOCK", "", "", "",
            "CERTI SALE STOCK", "", "", "",
            "NON CERTI BALANCE STOCK", "", "", "",
            "NON CERTI SALE STOCK", "", "", ""
        ]);

        worksheet.mergeCells("A3:A4");
        worksheet.mergeCells("B3:H3");
        worksheet.mergeCells("I3:J3");
        worksheet.mergeCells("K3:N3");
        worksheet.mergeCells("O3:R3");
        worksheet.mergeCells("S3:V3");
        worksheet.mergeCells("W3:Z3");

        // ===== HEADER ROW 2 =====
        const row2 = worksheet.addRow([
            "",
            "DATE", "ROUGHT WT.", "POLISH WT.", "CP", "AP", "DIFF", "DIFF POL WT.",
            "PCS", "WEIGHT",
            "PCS", "RATE($)/CRT", "WEIGHT", "VALUE($)",
            "SALE PCS", "SALE RATE($)/CRT", "SALE WT.", "SALE VALUE($)",
            "PCS", "RATE($)/CRT", "WEIGHT", "VALUE($)",
            "SALE PCS", "SALE RATE($)/CRT", "SALE WT.", "SALE VALUE($)"
        ]);

        // ===== Header Styling =====
        [row1, row2].forEach(row => {
            row.eachCell(cell => {
                cell.font = { bold: true };
                cell.alignment = { horizontal: "center", vertical: "middle" };
                cell.border = {
                    top: { style: "thin" },
                    bottom: { style: "thin" },
                    left: { style: "thin" },
                    right: { style: "thin" }
                };
            });
        });

        // ===== Header Colors =====
        const fillColor = (cell, color) => {
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: color }
            };
        };

        row1.eachCell((cell, col) => {
            if (col >= 2 && col <= 8) fillColor(cell, "FFFFCCCC");
            if (col >= 9 && col <= 10) fillColor(cell, "FFCCFFFF");
            if (col >= 11 && col <= 14) fillColor(cell, "FFFFE0CC");
            if (col >= 15 && col <= 18) fillColor(cell, "FFFFE0CC");
            if (col >= 19 && col <= 21) fillColor(cell, "FFCCE5FF");
            if (col >= 23 && col <= 26) fillColor(cell, "FFCCE5FF");
        });

        // ===== Filter Data =====
        let exportData = data;
        if (selectedLots?.length > 0) {
            exportData = data.filter(ele => selectedLots.includes(ele.L_Code));
        }

        // ===== Data Rows =====
        // ===== Data Rows =====
        exportData.forEach(row => {

            const diffValue =
                fixNum(row.Avg_Price) -
                fixNum(row.KP_LotCost);

            const newRow = worksheet.addRow([
                row.L_Code + " " + row.L_Name,
                formatDate(row.L_InwardDate),

                fixNum(row.KP_L_Carat),
                fixNum(row.KP_P_Carat),
                fixNum(row.KP_LotCost),

                fixNum(row.Avg_Price),
                diffValue,
                fixNum(row.Diff_Pol_Wt),

                fixNum(row.KP_Dem_Pcs),
                fixNum(row.KP_Dem_Carat),

                fixNum(row.CB_Pcs),
                fixNum(row.CB_AvgRateD),
                fixNum(row.CB_Carat),
                fixNum(row.CB_AmountD),

                fixNum(row.CS_Pcs),
                fixNum(row.CS_AvgRateD),
                fixNum(row.CS_Carat),
                fixNum(row.CS_AmountD),

                fixNum(row.NCB_Pcs),
                fixNum(row.NCB_AvgRateD),
                fixNum(row.NCB_Carat),
                fixNum(row.NCB_AmountD),

                fixNum(row.NCS_Pcs),
                fixNum(row.NCS_AvgRateD),
                fixNum(row.NCS_Carat),
                fixNum(row.NCS_AmountD)
            ]);

            newRow.eachCell((cell, col) => {
                let color = null;

                if (col >= 2 && col <= 8) color = "FFFFE5E5";
                else if (col >= 9 && col <= 10) color = "FFE5FFFF";
                else if (col >= 11 && col <= 18) color = "FFFFF0E5";
                else if (col >= 19 && col <= 26) color = "FFE5F0FF";

                if (color) {
                    cell.fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: color }
                    };
                }

                if (col >= 3) {
                    applyNumberFormat(cell);
                }

                cell.border = {
                    top: { style: "thin" },
                    bottom: { style: "thin" },
                    left: { style: "thin" },
                    right: { style: "thin" }
                };
            });



            // Diff (Column G = 7)
            applyPositiveNegativeColor(
                newRow.getCell(7),
                diffValue
            );


        });

        // ===== Totals Function =====
        // const exportTotals = () => {
        //     const init = {
        //         KP_L_Carat: 0,
        //         KP_P_Carat: 0,
        //         KP_LotCost: 0,
        //         KP_Dem_Carat: 0,
        //         KP_Dem_Pcs: 0,

        //         CB_Carat: 0,
        //         CB_Pcs: 0,
        //         CB_AmountD: 0,

        //         CS_Carat: 0,
        //         CS_Pcs: 0,
        //         CS_AmountD: 0,

        //         NCB_Carat: 0,
        //         NCB_Pcs: 0,
        //         NCB_AmountD: 0,

        //         NCS_Carat: 0,
        //         NCS_Pcs: 0,
        //         NCS_AmountD: 0,
        //     };

        //     return exportData.reduce((acc, row) => {
        //         Object.keys(init).forEach(key => {
        //             acc[key] += Number(row[key]) || 0;
        //         });
        //         return acc;
        //     }, init);
        // };

        //  const totals = exportTotals();

        // ===== Total Row =====
        const totalRow = worksheet.addRow([
            "TOTAL", "",
            totals.KP_L_Carat,
            totals.KP_P_Carat,
            totals.Avg_CP.toFixed(2),
            totals.Avg_Price.toFixed(2),
            totals.Diff.toFixed(2),
            totals.Diff_Pol_Wt,
            totals.KP_Dem_Pcs,
            totals.KP_Dem_Carat,

            totals.CB_Pcs,
            funCalAvgRate(totals.CB_AmountD, totals.CB_Carat),
            totals.CB_Carat,
            totals.CB_AmountD,

            totals.CS_Pcs,
            funCalAvgRate(totals.CS_AmountD, totals.CS_Carat),
            totals.CS_Carat,
            totals.CS_AmountD,

            totals.NCB_Pcs,
            funCalAvgRate(totals.NCB_AmountD, totals.NCB_Carat),
            totals.NCB_Carat,
            totals.NCB_AmountD,

            totals.NCS_Pcs,
            funCalAvgRate(totals.NCS_AmountD, totals.NCS_Carat),
            totals.NCS_Carat,
            totals.NCS_AmountD
        ]);

        totalRow.eachCell((cell, col) => {

            cell.font = { bold: true };

            if (col >= 3) {
                applyNumberFormat(cell);
            }

            cell.border = {
                top: { style: "thin" },
                bottom: { style: "thin" },
                left: { style: "thin" },
                right: { style: "thin" }
            };
        });

        // CP


        // ===== Column Width =====
        worksheet.columns.forEach(col => col.width = 14);

        // ===== Export =====
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), "LotWiseCosting.xlsx");
    };
    const handleLotSelect = (lotCode) => {
        setSelectedLots((prev) => {
            if (prev.includes(lotCode)) {
                // unselect
                return prev.filter(code => code !== lotCode);
            } else {
                // select
                return [...prev, lotCode];
            }
        });
    };
    const funFormatDate = (date) => {
        if (!date) return ""; // null, undefined, empty

        const d = new Date(date);

        // check invalid date
        if (isNaN(d.getTime())) return "";

        // format: DD-MM-YYYY
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();

        return `${day}-${month}-${year}`;
    };
    if (isError) {
        return <ErrorCard />
    }
    if (isPending) {
        return <LoadingCard />
    }
    return (
        <MainContainer
            pageName="Single Packet Lot Wise Costing Report"
            breadcrumbs={["Reports", "Single Packet Lot Wise Costing Report"]}
        >
            <div className="bg-white p-2 h-screen">

                {/*  <div className="p-2 shadow mb-5">
                   <div className="pb-1 text-sm font-semibold">
                        Inward Date
                    </div> */}
                {/* <div className="flex gap-2  flex-wrap sm:flex-nowrap md:flex-nowrap justify-center items-center gap-5 ">
                        <div className="flex no-wrap gap-5">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label={"From Date"}
                                    views={["day", "month", "year"]}
                                    size="small"
                                    format="DD/MM/YYYY"
                                    value={
                                        inwardDate.fromDate
                                            ? dayjs(inwardDate.fromDate)
                                            : inwardDate.fromDate
                                    }
                                    onChange={(newValue) => {
                                        setInwardDate((prev) => {
                                            return {
                                                ...prev,
                                                fromDate: newValue != '' && newValue != 'Invalid Date' ?
                                                    dayjs(newValue).format("YYYY-MM-DD") : null,
                                            };
                                        });
                                    }}
                                    slotProps={{
                                        textField: { size: "small", },
                                    }}
                                />
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label={"To  Date"}
                                    views={["day", "month", "year"]}
                                    format="DD/MM/YYYY"
                                    size="small"
                                    value={
                                        inwardDate.toDate
                                            ? dayjs(inwardDate.toDate)
                                            : inwardDate.toDate
                                    }
                                    onChange={(newValue) => {
                                        setInwardDate((prev) => {
                                            return {
                                                ...prev,
                                                toDate: newValue != '' && newValue != 'Invalid Date' ?
                                                    dayjs(newValue).format("YYYY-MM-DD") : null,
                                            };
                                        });
                                    }}
                                    slotProps={{
                                        textField: { size: "small", },
                                    }}
                                />
                            </LocalizationProvider>
                        </div>
                        <div className="flex no-wrap gap-5 justify-center items-center">
                            <Button onPress={handleFilter} className="font-semibold uppercase bg-slate-700 text-white" variant="solid" color="primary" size="sm" >Get Stock</Button>
                            <Button onPress={handleClear} className="font-semibold uppercase " variant="solid" color="danger" size="sm" >Clear Date</Button>
                        </div>
                    </div> 
                </div>*/}
                {data && data.length > 0 ? <div>
                    <div className="flex justify-between">
                        <h2 className="text-red-600  uppercase text-xs  font-semibold text-sm">Total Records : {data?.length || 0}</h2>
                        <div className="flex justify-end mb-2 gap-4">
                            <button
                                onClick={exportToExcel}
                                className="px-3 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-700"
                            >
                                Export Excel
                            </button>
                            {/* <button
                            //onClick={exportToPDF}
                            className="px-3 py-1 text-xs bg-red-600 text-white rounded hover:bg-green-700"
                        >
                            Export PDF
                        </button> */}
                        </div>
                    </div>
                    <Input type="text" size="sm"
                        radius="none" placeholder="Search ...."
                        startContent={<FontAwesomeIcon className="text-gray-700" icon={faSearchPlus}></FontAwesomeIcon>}
                        variant="bordered" className="bg-white border-0  border-gray-300"
                        value={searchText} onChange={(e) => setSearchText(e.target.value)}  ></Input>
                    <div className="overflow-auto max-h-[70vh] border-1 border-slate-300 ">
                        <table className="min-w-full  border-separate border-spacing-0 text-sm">
                            {/* Header */}
                            <thead className="sticky top-0 z-40 bg-white shadow-md">
                                <tr className="">
                                    <th rowSpan="2"  className={` ${StickyLeftCell} whitespace-nowrap  `}>
                                        Lot No
                                    </th>
                                    
                                    <th style={{
                                        position: "sticky",
                                        left: `${STICKY_COL_WIDTH.lotNo}px`,
                                        zIndex: 20,
                                    }} colSpan={7} className={` bg-red-50 ${tblHeadClas}`}></th>
                                    <th colSpan={2} style={{
                                        position: "sticky",
                                        //left:730px
                                        left: `${((6 * STICKY_COL_WIDTH.roughWt) + (STICKY_COL_WIDTH.lotNo + STICKY_COL_WIDTH.date)) - 5}px`,
                                        zIndex: 20,
                                    }} className={`  bg-cyan-50 ${tblHeadClas} `}>Planning</th>
                                    <th colSpan={4} className={` bg-orange-50 ${tblHeadClas}`}>Certi Balance Stock</th>
                                    <th colSpan={4} className={` bg-orange-50 ${tblHeadClas}`}>Certi Sale </th>
                                    <th colSpan={4} className={` bg-blue-50 ${tblHeadClas}`}>Non Certi Balance Stock</th>
                                    <th colSpan={4} className={` bg-blue-50 ${tblHeadClas}`}>Non Certi Sale </th>
                                </tr>
                                <tr className="">

                                    <th style={getStickyStyle("date", "head")}
                                        className={`  ${block_Color.HROW} ${tblHeadClas}`}
                                    >
                                        Date
                                    </th>

                                    <th style={getStickyStyle("roughWt", "head")}
                                        className={`   ${block_Color.HROW}  ${tblHeadClas}`}>
                                        Rough Weight
                                    </th>
                                    <th style={getStickyStyle("polishWt", "head")}
                                        className={`    ${block_Color.HROW}  ${tblHeadClas}`}>
                                        Polish Weight
                                    </th>
                                    <th style={getStickyStyle("cp", "head")}
                                        className={`   ${block_Color.HROW}  ${tblHeadClas}`}>
                                        CP
                                    </th>
                                    <th style={getStickyStyle("ap", "head")}
                                        className={`  }  ${block_Color.HROW}  ${tblHeadClas}`}>
                                        AP
                                    </th>
                                    <th style={getStickyStyle("diff", "head")}
                                        className={`  ${block_Color.HROW}  ${tblHeadClas}`}>
                                        Diff
                                    </th>
                                    <th style={getStickyStyle("diffPolWt", "head")}
                                        className={`  ${block_Color.HROW}  ${tblHeadClas}`}>
                                        Diff Pol Wt
                                    </th>
                                    <th style={getStickyStyle("planPcs", "head")}
                                        className={`  ${block_Color.HROW}  ${tblHeadClas} `}>
                                        Pcs
                                    </th>
                                    <th style={getStickyStyle("planWt", "head")}
                                        className={`   ${block_Color.HROW}  ${tblHeadClas}`}>
                                        Weight
                                    </th>

                                    <th className={`  ${block_Color.HROW}  ${tblHeadClas}`}>
                                        Pcs
                                    </th>
                                    <th className={` ${block_Color.HROW}  ${tblHeadClas}`}>
                                        Rate($)/CRT
                                    </th>
                                    <th className={` ${block_Color.HROW}  ${tblHeadClas}`}>
                                        Weight
                                    </th>
                                    <th className={` ${block_Color.HROW}  ${tblHeadClas}`}>
                                        Value($)
                                    </th>

                                    <th className={` ${block_Color.HROW}  ${tblHeadClas}`}>
                                        Sale Pcs
                                    </th>
                                    <th className={` ${block_Color.HROW}  ${tblHeadClas}`}>
                                        Sale Rate($)/CRT
                                    </th>
                                    <th className={` ${block_Color.HROW} ${tblHeadClas}`}>
                                        Sale Weight
                                    </th>
                                    <th className={` ${block_Color.HROW} ${tblHeadClas}`}>
                                        Sale Value($)
                                    </th>

                                    <th className={` ${block_Color.HROW}  ${tblHeadClas}`}>
                                        Pcs
                                    </th>
                                    <th className={` ${block_Color.HROW} ${tblHeadClas}`}>
                                        Rate($)/CRT
                                    </th>
                                    <th className={` ${block_Color.HROW}  ${tblHeadClas}`}>
                                        Weight
                                    </th>
                                    <th className={` ${block_Color.HROW} ${tblHeadClas}`}>
                                        Value($)
                                    </th>
                                    <th className={` ${block_Color.HROW} ${tblHeadClas}`}>
                                        Sale Pcs
                                    </th>
                                    <th className={` ${block_Color.HROW} ${tblHeadClas}`}>
                                        Sale Rate($)/CRT
                                    </th>
                                    <th className={`${block_Color.HROW} ${tblHeadClas}`}>
                                        Sale Weight
                                    </th>
                                    <th className={` ${block_Color.HROW} ${tblHeadClas}`}>
                                        Sale Value($)
                                    </th>
                                </tr>

                            </thead>

                            {/* Body */}
                            <tbody>
                                {data.map((row) => (
                                    <tr key={row.sl_code} className="hover:bg-gray-50">
                                        <td className={` bg-gray-50 ${StickyLeftCell} `} >
                                            <div className="flex w-full items-center gap-2" style={{ fontSize: "0.8rem" }}>
                                                <input
                                                    type="checkbox"
                                                    className="w-3 h-3 text-indigo-600 bg-white border border-gray-300 rounded focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1 transition duration-150 cursor-pointer"
                                                    checked={selectedLots.includes(row.L_Code)}
                                                    onChange={() => handleLotSelect(row.L_Code)}
                                                />
                                                <div className="text-sm"> {row.L_Code}</div>

                                            </div>
                                            
                                                <div style={{ fontSize: "0.7rem", }} className={`  py-1 whitespace-normal  text-red-600`} >  {row.L_Name ||""}</div> 

                                        </td>
                                        <td style={getStickyStyle("date")} className={`   ${block_Color.LOT} ${tbltdClass} `}>{funFormatDate(row.L_InwardDate)}</td>
                                        <td style={getStickyStyle("roughWt")} className={` ${block_Color.LOT} ${tbltdClass}`}>{fixed(row.KP_L_Carat)}</td>
                                        <td style={getStickyStyle("polishWt")} className={`  ${block_Color.LOT} ${tbltdClass}`}>{fixed(row.KP_P_Carat)}</td>
                                        <td style={getStickyStyle("cp")} className={` ${block_Color.LOT} ${tbltdClass}`}>{fixed(row.KP_LotCost)}</td>
                                        <td style={getStickyStyle("ap")} className={`  ${block_Color.LOT} ${tbltdClass}`}>{fixed(row.Avg_Price)}</td>
                                        <td style={getStickyStyle("diff")} className={`  ${block_Color.LOT} ${tbltdClass} ${fixed(row.Avg_Price - row.KP_LotCost) < 0 ? "text-red-500" : "text-green-500 "}  font-semibold`}>{fixed(row.Avg_Price - row.KP_LotCost)}</td>
                                        <td style={getStickyStyle("diffPolWt")} className={`  ${block_Color.LOT} ${tbltdClass} ${row.Diff_Pol_Wt < 0 ? "text-red-500" : "text-green-500 "}  font-semibold`}>{fixed(row?.Diff_Pol_Wt)}</td>
                                        <td style={getStickyStyle("planPcs")} className={`  ${block_Color.KP} ${tbltdClass} bg-cyan-100`}>{row?.KP_Dem_Pcs}</td>
                                        <td style={getStickyStyle("planWt")} className={`border-r-2 border-r-slate-500   ${block_Color.KP} ${tbltdClass}`}>{fixed(row.KP_Dem_Carat)}</td>
                                        <td className={` ${block_Color.CD} ${tbltdClass}`}>{row?.CB_Pcs}</td>
                                        <td className={` ${block_Color.CD} ${tbltdClass}`}>{fixed(row.CB_AvgRateD)}</td>
                                        <td className={` ${block_Color.CD} ${tbltdClass}`}>{fixed(row.CB_Carat)}</td>
                                        <td className={` ${block_Color.CD} ${tbltdClass}`}>{fixed(row.CB_AmountD)}</td>
                                        <td className={` ${block_Color.CD} ${tbltdClass}`}>{row?.CS_Pcs}</td>
                                        <td className={` ${block_Color.CD} ${tbltdClass}`}>{fixed(row.CS_AvgRateD)}</td>
                                        <td className={` ${block_Color.CD} ${tbltdClass}`}>{fixed(row.CS_Carat)}</td>
                                        <td className={` ${block_Color.CD} ${tbltdClass}`}>{fixed(row.CS_AmountD)}</td>
                                        <td className={` ${block_Color.NCD} ${tbltdClass}`}>{row?.NCB_Pcs}</td>
                                        <td className={` ${block_Color.NCD} ${tbltdClass}`}>{fixed(row.NCB_AvgRateD)}</td>
                                        <td className={` ${block_Color.NCD} ${tbltdClass}`}>{fixed(row.NCB_Carat)}</td>
                                        <td className={` ${block_Color.NCD} ${tbltdClass}`}>{fixed(row.NCB_AmountD)}</td>
                                        <td className={` ${block_Color.NCD} ${tbltdClass}`}>{row?.NCS_Pcs}</td>
                                        <td className={` ${block_Color.NCD} ${tbltdClass}`}>{fixed(row.NCS_AvgRateD)}</td>
                                        <td className={` ${block_Color.NCD} ${tbltdClass}`}>{fixed(row.NCS_Carat)}</td>
                                        <td className={` ${block_Color.NCD} ${tbltdClass}`}>{fixed(row.NCS_AmountD)}</td>

                                    </tr>
                                ))}
                            </tbody>

                            {/* Footer */}
                            <tfoot className="sticky z-30 bottom-0 bg-white font-bold shadow-[0_-4px_10px_rgba(0,0,0,0.12)]">
                                <tr>
                                    <td className={`${StickyLeftCell}`}>TOTAL</td>

                                    {/* LOT */}
                                    <td style={getStickyStyle("date", "head")}></td>
                                    <td style={getStickyStyle("roughWt", "head")} className={tblfootdClass}>{totals.KP_L_Carat.toFixed(2)}</td>
                                    <td style={getStickyStyle("polishWt", "head")} className={tblfootdClass}>{totals.KP_P_Carat.toFixed(2)}</td>
                                    <td style={getStickyStyle("cp", "head")} className={tblfootdClass}>{totals.Avg_CP.toFixed(2)}</td>
                                    <td style={getStickyStyle("ap", "head")} className={tblfootdClass}>{totals.Avg_Price.toFixed(2)}</td>
                                    <td style={getStickyStyle("diff", "head")} className={tblfootdClass}>{totals.Diff.toFixed(2)}</td>
                                    <td style={getStickyStyle("diffPolWt", "head")} className={tblfootdClass}>{totals.Diff_Pol_Wt.toFixed(2)}</td>
                                    {/* KP */}
                                    <td style={getStickyStyle("planPcs", "head")} className={`${tblfootdClass} `}>{totals.KP_Dem_Pcs}</td>
                                    <td style={{
                                        position: "sticky",
                                        // left: `810px`,
                                        left: `${((7 * STICKY_COL_WIDTH.roughWt) + (STICKY_COL_WIDTH.lotNo + STICKY_COL_WIDTH.date))}px`,
                                        zIndex: 20,
                                        width: `80px`,
                                        minWidth: `80px`,
                                        background: "white"
                                    }} className={tblfootdClass}>{totals.KP_Dem_Carat.toFixed(2)}</td>

                                    {/* CB */}
                                    <td className={tblfootdClass}>{totals.CB_Pcs}</td>
                                    <td className={tblfootdClass}>{funCalAvgRate(totals.CB_AmountD, totals.CB_Carat).toFixed(2)}</td>
                                    <td className={tblfootdClass}>{totals.CB_Carat.toFixed(2)}</td>
                                    <td className={tblfootdClass}>{totals.CB_AmountD.toFixed(2)}</td>

                                    {/* CS */}
                                    <td className={tblfootdClass}>{totals.CS_Pcs}</td>
                                    <td className={tblfootdClass}>{funCalAvgRate(totals.CS_AmountD, totals.CS_Carat).toFixed(2)}</td>
                                    <td className={tblfootdClass}>{totals.CS_Carat.toFixed(2)}</td>
                                    <td className={tblfootdClass}>{totals.CS_AmountD.toFixed(2)}</td>

                                    {/* NCB */}
                                    <td className={tblfootdClass}>{totals.NCB_Pcs}</td>
                                    <td className={tblfootdClass}>{funCalAvgRate(totals.NCB_AmountD, totals.NCB_Carat).toFixed(2)}</td>
                                    <td className={tblfootdClass}>{totals.NCB_Carat.toFixed(2)}</td>
                                    <td className={tblfootdClass}>{totals.NCB_AmountD.toFixed(2)}</td>

                                    {/* NCS */}
                                    <td className={tblfootdClass}>{totals.NCS_Pcs}</td>
                                    <td className={tblfootdClass}>{funCalAvgRate(totals.NCS_AmountD, totals.NCS_Carat).toFixed(2)}</td>
                                    <td className={tblfootdClass}>{totals.NCS_Carat.toFixed(2)}</td>
                                    <td className={tblfootdClass}>{totals.NCS_AmountD.toFixed(2)}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div> : <div className="text-center text-gray-500 text-xs">  No  Records Found ..</div>}
            </div>
        </MainContainer>
    );
};

export default LotWiseCostingReport;
